import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    fbq: (...args: any[]) => void;
  }
}

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view in Google Analytics
    if (window.gtag) {
      window.gtag('config', 'G-XXXXXXXXXX', {
        page_path: location.pathname + location.search,
      });
    }

    // Track page view in Meta Pixel
    if (window.fbq) {
      window.fbq('track', 'PageView');
    }
  }, [location]);
};

export const trackEvent = (eventName: string, params?: Record<string, any>) => {
  // Google Analytics event
  if (window.gtag) {
    window.gtag('event', eventName, params);
  }

  // Meta Pixel event
  if (window.fbq) {
    window.fbq('track', eventName, params);
  }
};

export const trackConversion = (value?: number) => {
  trackEvent('conversion', { value, currency: 'USD' });
};

export const trackLeadGeneration = (method: string) => {
  trackEvent('generate_lead', { method });
};
